var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisaCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "26px",
    viewBox: "0 0 44 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Credit Card/Visa/Visa-card-dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fives---03---Booking",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.2.8---Booking---casual---confirm-booking-/-summary",
    transform: "translate(-108.000000, -749.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Credit-Card/Visa/Visa-card-dark",
    transform: "translate(108.000000, 749.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#26337A",
    x: 0,
    y: 0,
    width: 43.3333333,
    height: 26,
    rx: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-3",
    fill: "#FFFFFF",
    points: "17.978996 17.1369296 19.3113822 8.87149296 21.4411536 8.87149296 20.1088892 17.1369296 17.978996 17.1369296"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8342441,9.0743662 C27.4131379,8.90847887 26.7508429,8.72757746 25.9258061,8.72757746 C23.8201536,8.72757746 22.3379379,9.84923944 22.3256349,11.4553803 C22.3122355,12.643446 23.3833336,13.3060188 24.1908293,13.7009014 C25.0207386,14.1056714 25.2995676,14.3646948 25.2962786,14.7266197 C25.2905535,15.2801878 24.6338618,15.5338404 24.0215098,15.5338404 C23.1688217,15.5338404 22.7158006,15.4089671 22.0153782,15.100385 L21.7414217,14.9687981 L21.4435899,16.8189484 C21.9402198,17.0491643 22.8608794,17.2489859 23.8163774,17.2594836 C26.0541966,17.2594836 27.5082736,16.1513709 27.5253273,14.4362254 C27.5330015,13.4941221 26.9654767,12.7800376 25.7363876,12.1904601 C24.9921126,11.8071737 24.5353154,11.553277 24.5405533,11.1653521 C24.5410406,10.8218592 24.9264556,10.4540751 25.7606283,10.4540751 C26.4572745,10.4428451 26.9615786,10.6037277 27.3545461,10.7716901 L27.5457919,10.866169 L27.8342441,9.0743662",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6701631,14.2064977 C30.8466696,13.7314178 31.5185879,11.8961596 31.5185879,11.8961596 C31.506163,11.9180094 31.6941198,11.4174178 31.8016803,11.107615 L31.9454192,11.8204789 C31.9454192,11.8204789 32.3541005,13.7933052 32.438273,14.2064977 L30.6701631,14.2064977 L30.6701631,14.2064977 Z M33.2976608,8.87991549 L31.651729,8.87991549 C31.1412124,8.87991549 30.7590863,9.02615023 30.5354384,9.56507042 L27.3725743,17.1398592 L29.6095409,17.1398592 C29.6095409,17.1398592 29.9744914,16.1208545 30.057324,15.89723 C30.3013146,15.89723 32.4749386,15.9015023 32.7851952,15.9015023 C32.849025,16.1899437 33.0445343,17.1398592 33.0445343,17.1398592 L35.0213091,17.1398592 L33.2976608,8.87991549 L33.2976608,8.87991549 Z",
    id: "Fill-5",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1922488,8.8784507 L14.1076699,14.513493 L13.8843874,13.3680282 C13.495927,12.0482535 12.2866934,10.6177653 10.9340863,9.90099531 L12.8411843,17.1297277 L15.0952046,17.128385 L18.4491926,8.8784507 L16.1922488,8.8784507",
    id: "Fill-6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.172555,8.87283568 L8.73804885,8.87283568 L8.70978833,9.0440939 C11.3822349,9.72876056 13.1504665,11.3814085 13.8843874,13.3680282 L13.1380416,9.57019718 C13.0092857,9.04641315 12.6350774,8.89114554 12.172555,8.87283568",
    id: "Fill-7",
    fill: "#EC982D"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCard);
export default __webpack_public_path__ + "static/media/visa-card.3e5d6c35fa70a91c5f737bdd5f7110a3.svg";
export { ForwardRef as ReactComponent };